import endpoints from "@/utils/constants";
import { apiHelper, authHelper } from "@/utils/helpers";

const actions = {
  saveVendor(context) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "post",
          `${endpoints.BASE_URL}${endpoints.API.vendors}`,
          context.state.vendor
        )
        .then(res => {
          if (res.status === 201) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getVendorList(context, query) {
    const url = new URL(`${endpoints.BASE_URL}${endpoints.API.vendors}`);
    if (query) {
      url.search = new URLSearchParams(query);
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            context.commit("setVendorList", res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  fetchVendor(context, vendorId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.BASE_URL}${endpoints.API.vendors}/${vendorId}`
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setVendor", res.data);
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  updateVendor(context) {
    if (context.state.vendor.adharCard === "") {
      delete context.state.vendor.adharCard;
    }
    if (context.state.vendor.panCard === "") {
      delete context.state.vendor.panCard;
    }
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "put",
          `${endpoints.BASE_URL}${endpoints.API.vendors}/${context.state.vendor.vendorId}`,
          context.state.vendor
        )
        .then(res => {
          if (res.status === 200) {
            context.commit("setVendor", res.data);
            resolve(res);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  changeVendorPassword(context, password) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "patch",
          `${endpoints.BASE_URL}${endpoints.API.vendors}/${context.state.vendor.vendorId}/change/password`,
          password
        )
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getVendorMonthwisePoints(context, query) {
    const url = new URL(
      `${endpoints.BASE_URL}${endpoints.API.vendors}/${query.vendorId}/monthwise/average-points`
    );
    return new Promise((resolve, reject) => {
      apiHelper
        .call("get", url)
        .then(res => {
          if (res.status === 200) {
            resolve(res.data);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getMonthlyAveragePointsOfVendor(_, payload) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/average/points?date=${payload}`
        )
        .then(res => {
          resolve(res);
        });
    }).catch(err => {
      reject(err);
    });
  },

  getMonthwiseVendorPointsAndPenalties(_, payload) {
    const month = payload ? `${payload}` : "";
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/vendor-points/monthwise?month=${month}`
        )
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  getVendorLabors(_, vendorId) {
    return new Promise((resolve, reject) => {
      apiHelper
        .call(
          "get",
          `${endpoints.LARAVEL_BASE_URL}/api/v1/labors/vendors/${vendorId}`
        )
        .then(res => {
          resolve(res);
        });
    }).catch(err => {
      reject(err);
    });
  }
};
export default actions;
